module.exports = __webpack_public_path__ + "media/images/flags/1x1/eth-a34a245cef45d8427820455fa1adda3e.svg";